export default {
    fields: {
        apiData: {
            "items": [
                {
                "id": 53603,
                "titleUrl": "magnum220",
                "title": "Magnum™ 220",
                "formattedTitle": null,
                "description": "With the industry's largest cab featuring a choice of ergonomically designed packages and 360-degree visibility, long working days won't seem so long in the Magnum™ 220.",
                "icon": null,
                "bigthumbnail": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
                "bigthumbnailAlt": null,
                "thumbnail": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
                "thumbnailAlt": null,
                "full": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
                "fullAlt": null
                },
                {
                "id": 53601,
                "titleUrl": "magnum180",
                "title": "Magnum™ 180",
                "formattedTitle": null,
                "description": "The 6.7L 180 hp Magnum™ 180 offers maximum versatility for your row-crop operations.&nbsp; Available in CVXDrive or PowerDrive powershift transmission.",
                "icon": null,
                "bigthumbnail": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
                "bigthumbnailAlt": null,
                "thumbnail": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
                "thumbnailAlt": null,
                "full": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
                "fullAlt": null
                },
                {
                "id": 53609,
                "titleUrl": "magnum380",
                "title": "Magnum™ 380",
                "formattedTitle": null,
                "description": "A state-of-the-art CVXDrive transmission is a standard feature on the Magnum™ 380.&nbsp; Available with RowTrac™ and front duals for maximum weight distribution and traction in any condition.",
                "icon": null,
                "bigthumbnail": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
                "bigthumbnailAlt": null,
                "thumbnail": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
                "thumbnailAlt": null,
                "full": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
                "fullAlt": null
                },
                {
                "id": 53604,
                "titleUrl": "magnum240",
                "title": "Magnum™ 240",
                "formattedTitle": null,
                "description": "The Magnum™ 240 comes standard with a easy-to-operate CVXDrive transmission, featuring a four-range design that increases efficiency and maximizes available power.",
                "icon": null,
                "bigthumbnail": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
                "bigthumbnailAlt": null,
                "thumbnail": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
                "thumbnailAlt": null,
                "full": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
                "fullAlt": null
                }
            ],
            "total": 4  
        },
        itemData:{
            "contextItemUrl": "/products/tractors/magnumseries"
        }
    }
}